import React, { useState } from 'react';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import ChatList from '../components/chat/ChatList';
import ChatRoom from '../components/chat/ChatRoom';
import ChatCreateModal from '../modal/ChatCreateModal';
import '../css/Chat.css';

const Chat = ({ isSidebarClosed, setIsSidebarClosed }) => {
  const [modalOpen, setModalOpen] = useState(false);

  const handleCreateRoom = (roomData) => {
    // A chat létrehozást a ChatContext kezeli
    setModalOpen(false);
  };

  return (
    <div>
      <Navbar isSidebarClosed={isSidebarClosed} setIsSidebarClosed={setIsSidebarClosed} />
      <Sidebar isCollapsed={isSidebarClosed} setIsCollapsed={setIsSidebarClosed} />
      <div className="page-content chat-page-content">
        <div className="chat-layout">
          <ChatList onCreateRoom={() => setModalOpen(true)} />
          <ChatRoom />
        </div>
        {modalOpen && (
          <ChatCreateModal
            onClose={() => setModalOpen(false)}
            onCreate={handleCreateRoom}
          />
        )}
      </div>
    </div>
  );
};

export default Chat; 